import { google_fonts_list } from 'data/google_fonts'
import AllIcons from './AllIcons'

export const borderRadiusOptionSelect = [
  {
    title: 'Uniform Border Radius',
    desc: 'Apply a consistent border radius to all corners of an element.',
    icon: AllIcons.border_all_corner,
    value: 'all_corner',
  },
  {
    title: 'Custom Corner Radius',
    desc: 'Individually adjust corner radius for unique designs.',
    icon: AllIcons.border_separate_corner,
    value: 'separated_corner',
  },
]

//

export const border_styles = [
  {
    key: 'border_radius',
    title: 'Border radius',
    type: 'select',
    value: '0px',
    is_required: false,
    style_group: 'borders',
  },

  {
    key: 'top_left_border_radius',
    title: 'Top Right Border radius',
    type: 'select',
    value: '0px',
    is_required: false,
    style_group: 'borders',
    icon: AllIcons.border_radius_top_left,
  },
  {
    key: 'top_right_border_radius',
    title: 'Border radius',
    type: 'select',
    value: '0px',
    is_required: false,
    style_group: 'borders',
    icon: AllIcons.border_radius_top_right,
  },
  {
    key: 'bottom_left_border_radius',
    title: 'Border radius',
    type: 'select',
    value: '0px',
    is_required: false,
    style_group: 'borders',
    icon: AllIcons.border_radius_bottom_left,
  },
  {
    key: 'bottom_right_border_radius',
    title: 'Border radius',
    type: 'select',
    value: '0px',
    is_required: false,
    style_group: 'borders',
    icon: AllIcons.border_radius_bottom_right,
  },

  // {
  //   key: 'font_family',
  //   title: 'Font family',
  //   type: 'select',
  //   value: 'primary_font',
  //   is_required: false,
  //   style_group: 'typography',
  //   drop_down_values: [
  //     { label: 'Primary font', value: 'primary_font' },
  //     { label: 'Title Font', value: 'title_font' },
  //     { label: 'Body font', value: 'body_font' },
  //     // ...google_fonts_list.map((font) => ({
  //     //   label: font.family,
  //     //   value: font.family,
  //     // })),
  //   ],
  // },
  // {
  //   key: 'font_weight',
  //   title: 'Font weight',
  //   style_group: 'typography',

  //   value: '500',
  //   type: 'select',
  //   value: 'primary_font',
  //   is_required: false,
  //   drop_down_values: [
  //     { label: '100 (Thin)', value: '100' },
  //     { label: '200 (Extra-Light)', value: '200' },
  //     { label: '300 (Light)', value: '300' },
  //     { label: '400 (Regular)', value: '400' },
  //     { label: '500 (Medium)', value: '500' },
  //     { label: '600 (Semi-Bold)', value: '600' },
  //     { label: '700 (Bold)', value: '700' },
  //     { label: '800 (Extra-Bold)', value: '800' },
  //   ],
  // },
  // {
  //   key: 'text_size',
  //   style_group: 'typography',

  //   value: '20px',
  //   type: 'input-px',
  //   title: 'Text size',
  //   is_required: false,
  // },
  // {
  //   key: 'line_height',
  //   style_group: 'typography',

  //   value: '20px',
  //   type: 'input-px',
  //   title: 'Line Height',
  //   is_required: false,
  // },
  // {
  //   key: 'text_color',
  //   style_group: 'typography',
  //   value: '#000000',
  //   type: 'color',
  //   title: 'Text Color',
  //   is_required: false,
  // },
  // {
  //   key: 'text_align',
  //   title: 'Text alignment',
  //   style_group: 'typography',
  //   type: 'select',
  //   value: 'start',
  //   is_required: false,
  //   drop_down_values: textAlignmentValues,
  // },
]
